import {
  browserSupportsWebAuthn,
  startAuthentication,
  startRegistration,
} from '@simplewebauthn/browser';
import type {
  PublicKeyCredentialCreationOptionsJSON,
  PublicKeyCredentialRequestOptionsJSON,
} from '@simplewebauthn/browser';
import type { IdentityApiClient } from './api-client';
import { identityErrorMessage } from './api-client';
import type { MemoryIdentitySessionStore } from './session-store';
import type { VerifyOtpResponse } from '@ghalishor/contracts';

export function passkeysSupported(): boolean {
  return browserSupportsWebAuthn();
}

export async function loginWithPasskey(
  api: IdentityApiClient,
  sessionStore: MemoryIdentitySessionStore,
  mobile: string,
): Promise<VerifyOtpResponse> {
  const optionsResponse = await api.passkeyLoginOptions(mobile);
  if (!optionsResponse.available) {
    throw new Error('برای این شماره Passkey فعالی ثبت نشده است. با کد پیامکی وارد شوید.');
  }
  const assertion = await startAuthentication({
    optionsJSON: optionsResponse.options as unknown as PublicKeyCredentialRequestOptionsJSON,
  });
  const verified = await api.passkeyLoginVerify(mobile, assertion as never);
  sessionStore.setAccessGrant(verified);
  return verified;
}

export async function registerPasskey(
  api: IdentityApiClient,
  deviceName?: string,
): Promise<string> {
  const { options } = await api.passkeyRegisterOptions();
  const attestation = await startRegistration({
    optionsJSON: options as unknown as PublicKeyCredentialCreationOptionsJSON,
  });
  const result = await api.passkeyRegisterVerify(attestation as never, deviceName);
  return result.credential.deviceName;
}

export async function loginWithRecoveryCode(
  api: IdentityApiClient,
  sessionStore: MemoryIdentitySessionStore,
  mobile: string,
  code: string,
): Promise<VerifyOtpResponse> {
  const verified = await api.recoveryVerify(mobile, code);
  sessionStore.setAccessGrant(verified);
  return verified;
}

export function passkeyUserMessage(error: unknown): string {
  if (error instanceof Error && error.name === 'NotAllowedError') {
    return 'عملیات Passkey لغو شد یا دستگاه پشتیبانی نکرد.';
  }
  return identityErrorMessage(error);
}
